export default [
  {
    path: '/zjd/claimQuery', // 自助理赔进度查询
    name: 'claimQuery',
    component: () => {
      return import(
        /* webpackChunkName: "claim" */ '@/views/claim/claimQuery.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/zjd/claimapply', // 自助理赔申请
    name: 'claimapply',
    component: () => {
      return import(
        /* webpackChunkName: "claim" */ '@/views/claim/claimapply.vue'
      )
    }
  },
  {
    path: '/zjd/appDetail', // 自助理赔详情查询
    name: 'appDetail',
    component: () => {
      return import(
        /* webpackChunkName: "claim" */ '@/views/claim/appDetail.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/zjd/claimsBusiness', // 理赔业务列表
    name: 'claimsBusiness',
    component: () => {
      return import(
        /* webpackChunkName: "claim" */ '@/views/claim/claimsBusiness.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/zjd/claimExplain', // 理赔解释
    name: 'claimExplain',
    component: () => {
      return import(
        /* webpackChunkName: "claim" */ '@/views/claim/claimExplain.vue'
      )
    }
  },
  {
    path: '/zjd/claimDetail', // 理赔解释
    name: 'claimDetail',
    component: () => {
      return import(
        /* webpackChunkName: "claim" */ '@/views/claim/claimDetail.vue'
      )
    }
  },
  {
    path: '/zjd/claimMaterial', // 理赔材料补充
    name: 'claimMaterial',
    component: () => {
      return import(
        /* webpackChunkName: "claim" */ '@/views/claim/claimMaterial.vue'
      )
    }
  },
  {
    path: '/zjd/claimGuide', // 自助理赔服务指南
    name: 'claimGuide',
    component: () => {
      return import(
        /* webpackChunkName: "claim" */ '@/views/claim/claimGuide.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/zjd/claimProve', // 自助理赔单证下载
    name: 'claimProve',
    component: () => {
      return import(
        /* webpackChunkName: "claim" */ '@/views/claim/claimProve.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  }
]
